export default {
  campaigns: [],
  campaignInfos: {
    id: null,
    mailchimp_id: null,
    subject_line: null,
    preview_text: null,
    title: null,
    from_name: null,
    reply_to: null,
    content: null,
    activated: null,
    created_at: null,
    updated_at: null,
    test_sent_at: null,
    sent_at: null,
    mailchimp_infos: {
      status: null,
      emails_sent: null,
      report_summary: {
        opens: 0,
        unique_opens: 0,
        open_rate: 0,
        clicks: 0,
        subscriber_clicks: 0,
        click_rate: 0,
      }
    }
  },
  totalPages: 1
}
